import { render, staticRenderFns } from "./DiscoverSection.vue?vue&type=template&id=4ff18eab&scoped=true&"
import script from "./DiscoverSection.vue?vue&type=script&lang=js&"
export * from "./DiscoverSection.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverSection.vue?vue&type=style&index=0&id=4ff18eab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff18eab",
  null
  
)

export default component.exports